import { createSlice } from "@reduxjs/toolkit";
import { removePresenterAction, presentersCreateAction, presentersListAction, presentersSchoolListAction, presentersUpdateAction } from "../Action/PresentersAction";


const initialState = {
   presenters:{},
   presentersSchoolList:{},
   presenterCreateStatus:"idle",
   presentersUpdateStatus:"idle",
   removePresenterActionStatus:"idle",
}

const presentersSlice = createSlice({
    name: 'presenters',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(presentersListAction.fulfilled, (state, action) => {
                state.presenters = action?.payload?.data;  
            })        
            .addCase(presentersSchoolListAction.fulfilled, (state, action) => {
                state.presentersSchoolList = action?.payload?.data;  
            }) 

            .addCase(presentersCreateAction.fulfilled, (state, action) => {
                state.presenterCreateStatus = 'succeeded';
            })        


            .addCase(presentersUpdateAction.fulfilled, (state, action) => {
                state.presentersUpdateStatus = 'succeeded';
            })     
            
            .addCase(removePresenterAction.fulfilled, (state, action) => {
                state.removePresenterActionStatus = 'succeeded';
            })     
            
            
    },
});

export default presentersSlice.reducer;
